module.exports = __webpack_public_path__ + "media/application/images/icons/arrow_back-3c2ffce2d95a11087c9839e0fa5d0b70.svg";